import { Injectable } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class AnimationsService {
    constructor() {}

    public prepareRoute = (outlet: RouterOutlet) => {
        return outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation;
    };
}
